<template>
	<div id="mapcomponent">
		<div v-if="!cookiesAllowed" class="no-cookies">
			<div class="fa-stack fa-1x">
				<i class="far fa-slash fa-stack-1x" style="color: red;"></i>
				<i class="far fa-cookie-bite fa-stack-1x"></i>
			</div>
			<div>
			<span v-if="currentLang === 'it'">
			  Mappa stradale fornita da OpenStreetMap bloccata in assenza di tua autorizzazione.
			  Per vederla, modifica le tue impostazioni sui cookie
			  e dai il consenso a OpenStreetMap.
			</span>
				<span v-if="currentLang === 'en'">
			  The map provided by OpenStreetMap was blocked, because your authorization is missing.
			  To see it, please update your cookie preferences
			  and allow OpenStreetMap,
			</span>
			</div>
		</div>

		<div v-if="cookiesAllowed">
			<!-- Map holder -->
			<div id="leaflet-container"></div>

			<!-- Menu Esplora toggle -->
			<button id="explore-button" class="btn btn-primary" type="button" data-bs-toggle="offcanvas" data-bs-target="#mapmenu" aria-controls="mapmenu">
				<svg style="margin-bottom: 3px" xmlns="http://www.w3.org/2000/svg" width="20" height="23" fill="currentColor" class="bi bi-list" viewBox="0 0 16 16">
					<path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
				</svg>

				{{ filtersMap[currentLang]['lbl-esplora'] }}
			</button>

			<div id="breadcrumb-container">
				<span>{{currentBreadcrumbs}}</span>
				<button class="btn btn-sm btn-outline-primary" @click="openInfo" v-if="currentInfoTarget > 0">Info</button>
			</div>

			<!-- Menu Esplora -->
			<div class="offcanvas offcanvas-start"
				 tabindex="-1"
				 id="mapmenu"
				 aria-labelledby="mapmenu">
	<!--			<div class="offcanvas-header">
					<h5 class="offcanvas-title" id="offcanvasLabel">&nbsp;</h5>
					<button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Chiudi"></button>
				</div>-->
				<div class="offcanvas-body" id="map-offcanvas-left">
					<button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Chiudi"></button>

					<!-- Scegli la modalità: mura o percorsi? -->
					<div id="leaflet-layers">
						<div>
							<h2>{{ filtersMap[currentLang]['lbl-timeline']}}</h2>

							<a href="/wp-content/themes/mvmr/static/timeline.jpg" class="to-lightbox">
								{{ filtersMap[currentLang]['lbl-timelinelink'] }}
							</a>

							<h2>{{ filtersMap[currentLang]['lbl-esplora'] }}</h2>

							<div class="form-check">
								<input class="form-check-input" type="radio" v-model="currentMode" value="1" id="mode-1">
								<label class="form-check-label" for="mode-1">{{ filtersMap[currentLang]['lbl-tracciati'] }}</label>
							</div>

							<div class="form-check">
								<input class="form-check-input" type="radio" v-model="currentMode" value="2" id="mode-2">
								<label class="form-check-label" for="mode-2">{{ filtersMap[currentLang]['lbl-percorsi'] }}</label>
							</div>

							<div class="form-check">
								<input class="form-check-input" type="radio" v-model="currentMode" value="3" id="mode-3">
								<label class="form-check-label" for="mode-3">{{ filtersMap[currentLang]['lbl-storie'] }}</label>
							</div>
						</div>
					</div>

					<!-- Scegli le mura -->
					<div id="leaflet-walls">
						<div v-if="currentMode == 1" id="epoch-select">
							<h2>{{ filtersMap[currentLang]['lbl-mura'] }}</h2>

							<div class="form-check">
								<input class="form-check-input" type="radio" v-model="currentEpoch" value="1" id="epoch-1">
								<label class="form-check-label" for="epoch-1">{{ filtersMap[currentLang]['lbl-serviane'] }}</label>
							</div>

							<div class="form-check">
								<input class="form-check-input" type="radio" v-model="currentEpoch" value="2" id="epoch-2">
								<label class="form-check-label" for="epoch-2">{{ filtersMap[currentLang]['lbl-aureliane'] }}</label>
							</div>

							<div class="form-check">
								<input class="form-check-input" type="radio" v-model="currentEpoch" value="3" id="epoch-3">
								<label class="form-check-label" for="epoch-3">{{ filtersMap[currentLang]['lbl-vaticane'] }}</label>
							</div>

							<div class="form-check">
								<input class="form-check-input" type="radio" v-model="currentEpoch" value="4" id="epoch-4">
								<label class="form-check-label" for="epoch-4">{{ filtersMap[currentLang]['lbl-urbaniane'] }}</label>
							</div>
						</div>
					</div>

					<!-- Scegli i percorsi -->
					<div id="leaflet-itineraries">
						<div v-if="currentMode == 2" id="itinerary-select">
							<h2>{{ filtersMap[currentLang]['lbl-percorsi'] }}</h2>

							<div class="form-check" v-for="item in allItineraries"">
								<input class="form-check-input" type="radio" v-model="currentItinerary" :value="item.id" :id="'itinerary-' + item.id">
								<label class="form-check-label" for="itinerary-1">{{item.description}}</label>
							</div>
						</div>
					</div>

					<!-- Scegli i temi -->
					<div id="leaflet-filters">
						<div v-if="currentMode == 3" id="topics-select">
							<h2>{{ filtersMap[currentLang]['lbl-temi'] }}</h2>

							<div class="form-check">
								<input class="form-check-input" type="checkbox" v-model="currentFilters" value="1" id="theme-1">
								<label class="form-check-label" for="theme-1">{{ filtersMap[currentLang]['1'] }}</label>
							</div>

							<div class="form-check">
								<input class="form-check-input" type="checkbox" v-model="currentFilters" value="2" id="theme-2">
								<label class="form-check-label" for="theme-2">{{ filtersMap[currentLang]['2'] }}</label>
							</div>

	<!--						<div class="form-check">
								<input class="form-check-input" type="checkbox" v-model="currentFilters" value="3" id="theme-3">
								<label class="form-check-label" for="theme-3">{{ filtersMap[currentLang]['3'] }}</label>
							</div>

							<div class="form-check">
								<input class="form-check-input" type="checkbox" v-model="currentFilters" value="4" id="theme-4">
								<label class="form-check-label" for="theme-4">{{ filtersMap[currentLang]['4'] }}</label>
							</div>

							<div class="form-check">
								<input class="form-check-input" type="checkbox" v-model="currentFilters" value="5" id="theme-5">
								<label class="form-check-label" for="theme-5">{{ filtersMap[currentLang]['5'] }}</label>
							</div>

							<div class="form-check">
								<input class="form-check-input" type="checkbox" v-model="currentFilters" value="6" id="theme-6">
								<label class="form-check-label" for="theme-6">{{ filtersMap[currentLang]['6'] }}</label>
							</div>-->
						</div>
					</div>

					<div id="go-holder">
						<button @click="vai" id="go-button" class="btn btn-primary">{{ filtersMap[currentLang]['lbl-vai'] }}</button>
					</div>
				</div>
			</div>

			<!-- POI popup offcanvas -->
		    <!--data-bs-scroll="true"-->
			<div class="offcanvas offcanvas-end popup-category"
				 tabindex="-1"
				 id="poi-popup-holder"
				 aria-labelledby="poi-popup-holder-lbl">
				<div class="offcanvas-header" v-bind:class="popupCategoryClass">
					<div class="category-name ico-lbl">
						<img :src="popupIcon" class="ico category-ico" />
						<div class="lbl category-lbl">{{ popupCategoryName }}</div>
					</div>
					<button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Chiudi"></button>
				</div>
				<div class="offcanvas-header poi-popup-holder-title-holder" v-bind:class="popupCategoryClass">
					<h5 class="offcanvas-title" id="poi-popup-holder-lbl" v-html="popupTitle"></h5>
				</div>

				<div class="offcanvas-body" v-bind:class="popupCategoryClass">
					<div id="popup-spinner" v-if="!isPopupReady">Caricamento in corso...</div>
					<div id="popup-body" v-if="isPopupReady" v-html="popupBody"></div>
					<div class="sep" v-bind:class="popupCategoryClass"></div>
				</div>
			</div>

			<!-- Go up and down buttons -->
			<a href="#top" id="go-up">
				<img src="../images/frecce-giu-tondo.png"  />
			</a>
			<a href="#footer" id="go-down">
				<img src="../images/frecce-giu-tondo.png" />
			</a>
		</div>
	</div>
</template>

<script>
import L from 'leaflet/dist/leaflet';
import 'leaflet/dist/leaflet.css';
import omnivore from '@mapbox/leaflet-omnivore/leaflet-omnivore';
import Offcanvas from 'bootstrap/js/dist/offcanvas';
const axios = require('axios');
import baguetteBox from 'baguettebox.js';
//import Lightbox from 'bs5-lightbox';


let mapLayerWalls = null;
let mapLayerItinerary = null;
let map = null;

let mapPoints = null;
let layerPoi = null;
let layerPorte = null;

let globalLang = '';

function getIconPortaLarge(nomePorta) {
	return L.icon({
		//iconUrl: '/wp-content/themes/mvmr/src/images/porta_esempio.png',
		iconUrl: '/wp-content/themes/mvmr/src/images/icone-porte/1x/' + nomePorta + ".png",
		shadowUrl: '/wp-content/themes/mvmr/src/images/ombra_porta.png',

		iconSize: [72, 102], // size of the icon
		shadowSize: [38, 6], // size of the shadow
		iconAnchor: [36, 102], // point of the icon which will correspond to marker's location
		shadowAnchor: [36, 5],  // the same for the shadow
		popupAnchor: [0, 0] // point from which the popup should open relative to the iconAnchor
	});
}

function getIconPortaSmall(nomePorta) {
	return L.icon({
		//iconUrl: '/wp-content/themes/mvmr/src/images/porta_esempio.png',
		iconUrl: '/wp-content/themes/mvmr/src/images/icone-porte/1x/' + nomePorta + ".png",
		shadowUrl: '/wp-content/themes/mvmr/src/images/ombra_porta.png',

		iconSize: [36, 51], // size of the icon
		shadowSize: [19, 3], // size of the shadow
		iconAnchor: [19, 51], // point of the icon which will correspond to marker's location
		shadowAnchor: [18, 2],  // the same for the shadow
		popupAnchor: [0, 0] // point from which the popup should open relative to the iconAnchor
	});
}

function getIconPoi(color) {
	return L.icon({
		iconUrl: '/wp-content/themes/mvmr/src/images/pin_' + color +'.png',
		shadowUrl: '/wp-content/themes/mvmr/src/images/ombra_categorie.png',

		iconSize: [33, 60], // size of the icon
		shadowSize: [38, 6], // size of the shadow
		iconAnchor: [16, 60], // point of the icon which will correspond to marker's location
		shadowAnchor: [16, 3],  // the same for the shadow
		popupAnchor: [0, 0] // point from which the popup should open relative to the iconAnchor
	});
}

/**
 * Aggiorna la mappa dopo che è stata selezionata un'epoca diversa.
 * @param epoch epoca attiva, tra 1 e 5
 * @param filters array con i filtri attivi (da definire)
 */
function updateEpoch(mode, epoch, filters, currentItinerary, popupCallback) {
	console.log("Mode is: " + mode);
	console.log("Itinerary is: " + currentItinerary);

	// I pin sono stati scaricati? Se no, richiedi scaricamento e torna qui
	// quando saranno stati scaricati.
	if (mapPoints === null) {
		axios.get('/wp-json/mvmr/v1/get_pins_for_map?lang=' + globalLang)
			.then(function (response) {
				mapPoints = response.data;
				updateEpoch(mode, epoch, filters, currentItinerary, popupCallback);
			})
			.catch(function (error) {
				/// TODO gestire errore
				console.log(error);
			});
		// Torna dopo con i dati
		return;
	}

	// Togli tutto dalla mappa, sia i punti che le porte
	if(layerPoi) {
		layerPoi.remove();
	}
	if(layerPorte) {
		layerPorte.remove();
	}

	// Metti tutti i Marker nei rispettivi array
	let porteArray = [];
	let poiArray = [];
	let allArray = [];
	let thingsArray = null;
	console.log(mapPoints);

	/*
	* Loop su tutti i punti
	* */
	for (const [key, poi] of Object.entries(mapPoints)) {
		let thisIcon = null;
		let zIndexOffset = 0;
		let thisCategoryId = null;
		let nomePorta = null;

		if(
			(mode == 1 && (typeof poi.epoca !== 'undefined' && poi.epoca[epoch])) // Epoche: mostra porte di questa epoca
			|| (mode == 3) // Storie dalle mura: mostra sempre le porte + POI delle categorie scelte
		) { // Mode: porte
			/* Questo potrebbe tranquillamente andare in due IF diversi. E' così perché inizialmente
			 * mostravamo anche le porte in modalità 3.
			* */
			if (mode == 1 && poi.isPorta == "1") {
				nomePorta = poi.post_name;

				if(nomePorta.match(/-en$/)) {
					nomePorta = nomePorta.substring(0, (nomePorta.length - 3));
					console.log("Abbreviated to" + nomePorta);
				}

				if(mode == 1) {
					// modalita` porte = icona normale
					thisIcon = getIconPortaLarge(nomePorta);
				}
				else if(mode == 3) {
					// modalita` storie dalle mura = icona piccola
					thisIcon = getIconPortaSmall(nomePorta);
				}

				thisCategoryId = '0'; // porta
				thingsArray = porteArray;
			}
			else if(mode == 3) { // Mode: storie dalle mura
				let color = 'blu';

				if(poi.categoria == 'luoghi') { color = 'azzurro'; thisCategoryId = '1'; }
				if(poi.categoria == 'personaggi') { color = 'rosso'; thisCategoryId = '2'; }
				if(poi.categoria == 'pellegrini') { color = 'azzurro'; thisCategoryId = '3'; }
				if(poi.categoria == 'assedi') { color = 'giallo'; thisCategoryId = '4'; }
				if(poi.categoria == 'fonti') { color = 'rosso'; thisCategoryId = '5'; }
				if(poi.categoria == 'fotografie') { color = 'verde'; thisCategoryId = '6'; }

				console.log(poi);

				if(!filters.includes(thisCategoryId)) {
					console.log("Filters does not include " + poi.categoria);
					continue;
				}
				console.log("Filters includes " + poi.categoria);

				thisIcon = getIconPoi(color);

				thingsArray = poiArray;
				zIndexOffset = 100;
			}
		}
		else if(mode == 2 && typeof poi.percorso[currentItinerary] !== 'undefined') { // Mode: Percorsi. Mostra spezzone mura + punti o porte
			if (poi.isPorta == "1") {
				nomePorta = poi.post_name;

				if(nomePorta.match(/-en$/)) {
					nomePorta = nomePorta.substring(0, (nomePorta.length - 3));
					console.log("Abbreviated to" + nomePorta);
				}

				thisIcon = getIconPortaSmall(nomePorta);

				thisCategoryId = '99';
				thingsArray = porteArray;
			}
			else {
				thisIcon = getIconPoi('azzurro_senza_icona');
				thingsArray = poiArray;
				zIndexOffset = 100;

				thisCategoryId = '99'; // percorso
			}

		}

		// Did we find an icon? If so, add it now to the correct layer
		if(thisIcon) {
			let marker = L.marker([poi.lat, poi.lon], {icon: thisIcon, zIndexOffset: zIndexOffset});
			marker.on('click', function () {
				console.log("Current popup: " + poi.ID + " Category: " + thisCategoryId);
				popupCallback(poi.ID, thisCategoryId, nomePorta);
			});
			thingsArray.push(marker);
			allArray.push(marker);
		}
	}

	// Porte e Poi contengono ognuno un array di Marker

	layerPorte = L.layerGroup(porteArray);
	layerPorte.addTo(map);

	layerPoi = L.layerGroup(poiArray);
	layerPoi.addTo(map);

	// Zoom to points

	if(mode != 1 || epoch != 1) {
		if(allArray.length > 0) {
			var group = L.featureGroup(allArray);
			map.fitBounds(group.getBounds());
		}
	}
}

export default {
	name: 'leaflet',
	data() {
		return {
			//currentLang: 'it',

			/// Modalita` generale: 1 = epoche, 2 = percorsi
			currentMode: -1,

			/// Epoca delle mura: 1 = serviane, 2 = aureliane, 3 = medioevali, 4 = seicento, 5 = oggi
			currentEpoch: -1,

			/// Percorsi: ID percorso qui
			currentItinerary: 0,

			/// Filtri selezionati
			currentFilters: ['1', '2', '3', '4', '5', '6'],

			/// Content ID for popup: close when null, open when anything is set & fetch it via AJAX
			currentPopupId: null,

			// Is popup ready, or is it still loading data?
			isPopupReady: false,

			/// Current title and body of the Popup
			popupTitle: null,
			popupBody: null,

			/// Data relative to the category of the popup
			popupCategoryId: null,
			popupNomePorta: '',

			/// All supported itineraries, {id: NN, description: name}
			allItineraries: [],

			/// The label for the breadcrumbs and the target of the Go link
			currentBreadcrumbs: '',
			currentInfoTarget: 0,

			filtersMap: {
				'it': {
					'x': 'Schede introduttive',
					'0': 'Le Porte',
					'1': 'I luoghi',
					'2': 'I personaggi',
					'3': 'Pellegrini e viaggiatori',
					'4': 'Assedi',
					'5': 'Fonti letterarie e documenti',
					'6': 'Galleria fotografica',
					'99': 'Itinerari',

					'lbl-timeline': 'Timeline',
					'lbl-timelinelink': 'Guarda la linea del tempo',

					'lbl-esplora': 'Esplora',

					'lbl-tracciati': 'Tracciati delle mura',
					'lbl-percorsi': 'Itinerari',
					'lbl-percorso': 'Itinerario',
					'lbl-storie': 'Storie dalle mura',

					'lbl-mura': 'Mura',

					'lbl-serviane': 'Serviane',
					'lbl-aureliane': 'Aureliane',
					'lbl-vaticane': 'Vaticane',
					'lbl-urbaniane': 'Urbaniane',

					'lbl-temi': 'Temi',

					'lbl-vai': 'Vai',
				},
				'en' : {
					'x': 'Introduction',
					'0': 'Gates',
					'1': 'Places',
					'2': 'People',
					'3': 'Pilgrims and travellers',
					'4': 'Sieges',
					'5': 'Literary sources and documents',
					'6': 'Photogallery',
					'99': 'Itineraries',

					'lbl-timeline': 'Timeline',
					'lbl-timelinelink': 'Open the timeline',

					'lbl-esplora': 'Explore',

					'lbl-tracciati': 'The walls',
					'lbl-percorsi': 'Itineraries',
					'lbl-percorso': 'Itinerary',
					'lbl-storie': 'Stories from the walls',

					'lbl-mura': 'Walls',

					'lbl-serviane': 'Serviane',
					'lbl-aureliane': 'Aureliane',
					'lbl-vaticane': 'Vaticane',
					'lbl-urbaniane': 'Urbaniane',

					'lbl-temi': 'Themes',

					'lbl-vai': 'Go',
				},
			},
		}
	},
	props: ['info', 'cookiesAllowed', 'currentLang'],

	// Attention: computed properties are cached!
	computed: {
		/*src: function() {
			return "https://player.vimeo.com/video/" + this.videoid + "?byline=0&portrait=0";
		},
		href: function() {
			return "https://vimeo.com/" + this.videoid;
		},*/
		popupCategoryName: function() {
			let self = this;
			return self.filtersMap[self.currentLang][self.popupCategoryId];
		},
		popupCategoryClass: function() {
			let self = this;
			return "popup-cat cat-" + self.popupCategoryId;
		},
		popupIcon: function() {
			let self = this;

			if(self.popupCategoryId == 0) {
				return '/wp-content/themes/mvmr/src/images/icone-popup/' + self.popupNomePorta + '.png';
			}
			else {
				return '/wp-content/themes/mvmr/src/images/icone-popup/ico-' + self.popupCategoryId + '.png';
			}
		}
	},

	// Generic watches, when nothing else fits
	watch: {
		cookiesAllowed: {
			handler: function(val) {
				let self = this;
				console.log('Cookies allowed prop changed: ' + val);
				if(val) {
					self.loadMap();
				}
			},
			immediate: true,
		},
		currentMode: function() {
			let self = this;
			console.log("Current mode: "); console.log(self.currentMode);

			updateEpoch(self.currentMode, self.currentEpoch, self.currentFilters, self.currentItinerary, function(id, catId, nomePorta) {
				self.currentPopupId = id;
				self.popupCategoryId = catId;
				self.popupNomePorta = nomePorta;
			});

			// Set or unset deafult walls
			if(self.currentMode != 1) {
				self.setDefaultWallsBackground();
			}

			// Set or unset current itinerary
			if(self.currentMode != 2) {
				self.currentItinerary = 0;
			}
			else {
				this.$nextTick(function () {
					self.currentItinerary = 2;
				});
			}

			self.updateBreadcrumbs();
		},

		currentItinerary: function() {
			let self = this;
			console.log("Current itinerary: "); console.log(self.currentItinerary);

			if(mapLayerItinerary !== null) {
				mapLayerItinerary.remove();
				mapLayerItinerary = null;
			}

			if(self.currentItinerary == 0) {
				return;
			}

			let url = '/wp-content/plugins/mvmr/public/files/output_itinerario_' + self.currentItinerary + '.kml';
			let kmlPath = L.geoJson(null, {
				style: function (feature) {
					return {
						color: '#158aff',
						weight: 7,
					};
				}
			});
			mapLayerItinerary = omnivore.kml(url, null, kmlPath);
			mapLayerItinerary.addTo(map);

			updateEpoch(self.currentMode, self.currentEpoch, self.currentFilters, self.currentItinerary, function(id, catId, nomePorta) {
				self.currentPopupId = id;
				self.popupCategoryId = catId;
				self.popupNomePorta = nomePorta;
			});

			console.log("All itineraries:");
			console.log(self.allItineraries);

			self.allItineraries.forEach((el) => {
				console.log("Loop over itineraries...");
				console.log(el);
				if(self.currentItinerary == el.id) {
					console.log("Link to page id: " + el.page_id);
					self.currentInfoTarget = el.page_id;
				}
			});

			self.updateBreadcrumbs();
		},

		currentEpoch: function() {
			let self = this;

			let layerName = 'output_';
			let color = '';
			if (self.currentEpoch == 1) {
				layerName = layerName + self.currentEpoch + '_serviane.kml';
				color = '#02ab9f';
			} else if (self.currentEpoch == 2) {
				layerName = layerName + self.currentEpoch + '_aureliane.kml';
				color = '#e85c52';
			} else if (self.currentEpoch == 3) {
				layerName = layerName + self.currentEpoch + '_medioevo.kml';
				//color = '#fbaf19';
				color = '#d98c00';
			} else if (self.currentEpoch == 4) {
				layerName = layerName + self.currentEpoch + '_seicento.kml';
				color = '#74b62d';
			}
			else {
				return;
			}

			if (mapLayerWalls !== null) {
				mapLayerWalls.remove();
			}

			// Prepare the background

			let url = '/wp-content/plugins/mvmr/public/files/' + layerName;

			let layerAureliane = L.geoJson(null, {
				style: function (feature) {
					return {
						color: color,
						weight: 4,
					};
				}
			});

			mapLayerWalls = omnivore.kml(url, null, layerAureliane);
			mapLayerWalls.addTo(map);

			// Fetch the POI and show them
			updateEpoch(self.currentMode, self.currentEpoch, self.currentFilters, self.currentItinerary, function(id, catId, nomePorta) {
				self.currentPopupId = id;
				self.popupCategoryId = catId;
				self.popupNomePorta = nomePorta;
			});

			self.updateBreadcrumbs();
		},

		currentFilters: function() {
			let self = this;
			console.log("Current filters: "); console.log(self.currentFilters);
			updateEpoch(self.currentMode, self.currentEpoch, self.currentFilters, self.currentItinerary, function(id, catId, nomePorta) {
				self.currentPopupId = id;
				self.popupCategoryId = catId;
				self.popupNomePorta = nomePorta;
			});
		},

		currentPopupId: function(newId, oldId) {
			let self = this;

			self.isPopupReady = false;

			if(newId == null) {
				return;
			}

			let myOffcanvas = document.getElementById('poi-popup-holder');
			myOffcanvas.addEventListener('hidden.bs.offcanvas', event => {
				console.log('Close the popup');
				self.currentPopupId = null;
			})

			var bsOffcanvas = new Offcanvas(myOffcanvas)
			bsOffcanvas.show();

			let getPath = 'pin';
			if(newId.charAt(0) === 'P') {
				getPath = 'pages';
				newId = (newId + '').substring(1);
			}

			axios.get('/wp-json/wp/v2/' + getPath + '/' + newId + '?lang=' + globalLang)
				.then(function (response) {
					self.updatePopup(response.data);
				})
				.catch(function (error) {
					/// TODO gestire errore
					console.log(error);
				});
		},

		popupBody: function() {

		}
	},

	methods: {
		updatePopup: function(responseData) {
			let self = this;

			console.log("Now update the popup.");

			self.popupTitle = responseData.title.rendered;
			self.popupBody = responseData.content.rendered;
			self.isPopupReady = true;

			//baguetteBox.run('.wp-block-gallery,:not(.wp-block-gallery)>.wp-block-image,.wp-block-media-text__media,.gallery,.wp-block-coblocks-gallery-masonry,.wp-block-coblocks-gallery-stacked,.wp-block-coblocks-gallery-collage,.wp-block-coblocks-gallery-offset,.wp-block-coblocks-gallery-stacked');
			//baguetteBox.run('.wp-block-gallery');

			this.$nextTick(function () {
				baguetteBox.run('.wp-block-gallery');
			});
		},

		updateBreadcrumbs: function() {
			let self = this;
			let bc = '';

			if(self.currentMode == 1) {
				bc = self.filtersMap[self.currentLang]['lbl-tracciati'] + " > ";
				if(self.currentEpoch == 1) {
					bc += self.filtersMap[self.currentLang]['lbl-serviane'];
					self.currentInfoTarget = 1;
					self.currentInfoTarget = 373;
					if(self.currentLang == 'en') {
						self.currentInfoTarget = 379;
					}
				}
				else if(self.currentEpoch == 2) {
					bc += self.filtersMap[self.currentLang]['lbl-aureliane'];
					self.currentInfoTarget = 364;
					if(self.currentLang == 'en') {
						self.currentInfoTarget = 371;
					}
				}
				else if(self.currentEpoch == 3) {
					bc += self.filtersMap[self.currentLang]['lbl-vaticane'];
					self.currentInfoTarget = 391;
					if(self.currentLang == 'en') {
						self.currentInfoTarget = 400;
					}
				}
				else if(self.currentEpoch == 4) {
					bc += self.filtersMap[self.currentLang]['lbl-urbaniane'];
					self.currentInfoTarget = 381;
					if(self.currentLang == 'en') {
						self.currentInfoTarget = 389;
					}
				}
			}
			else if(self.currentMode == 2) {
				bc = self.filtersMap[self.currentLang]['lbl-percorso'] + " " + self.currentItinerary;
			}
			else if(self.currentMode == 3) {
				bc = self.filtersMap[self.currentLang]['lbl-storie'];
				self.currentInfoTarget = 0;
			}

			self.currentBreadcrumbs = bc;
		},

		vai: function() {
			let self = this;

			let esploraMenuElement = document.getElementById("mapmenu");
			let esploraMenu = Offcanvas.getInstance(esploraMenuElement);
			esploraMenu.hide();

			self.openInfo();
		},

		openInfo: function() {
			let self = this;

			if(self.currentInfoTarget > 0) {
				self.currentPopupId = 'P' + self.currentInfoTarget;
				self.popupCategoryId = 'x';
			}
		},

		loadMap: function() {
			let self = this;

			this.$nextTick(function () {
				console.log('Activate map!');

				var southWest = L.latLng(41.845508, 12.568016),
					northEast = L.latLng(41.948368, 12.400732),
					bounds = L.latLngBounds(southWest, northEast);

				map = L.map('leaflet-container', {
					center: [41.890240, 12.491495],
					zoom: 14,
					maxBounds: bounds,
					maxZoom: 19,
					minZoom: 12,
				});

				function onMapClick(e) {
					console.log("You clicked the map at " + e.latlng);
				}

				map.on('click', onMapClick);

				L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
					attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
				}).addTo(map);



				let found = false;
				if(false && window.location.hash) {
					let hashes = window.location.hash.split('/');
					console.log("My hashes:");
					console.log(hashes);

					if(hashes.length > 1) {
						let chapter = hashes[1];
						if(chapter == 'storie') {
							this.currentMode = 3;
							found = true;
						}
						else if(chapter == 'itinerario') {
							this.currentMode = 2;
							this.currentItinerary = hashes[2];
							found = true;
						}
						else if(chapter == 'epoche') {
							this.currentMode = 1;
							this.currentEpoch = hashes[2];
							found = true;
						}
					}
				}

				if(!found) {
					this.currentMode = 1;
					this.currentEpoch = 1;
				}


				self.updateBreadcrumbs();

				//const bsOffcanvas = new bootstrap.Offcanvas('#mapmenu');
			});
		},

		setDefaultWallsBackground: function() {
			if (mapLayerWalls !== null) {
				mapLayerWalls.remove();
			}
			let layerMura = L.geoJson(null, {
				style: function (feature) {
					return {
						color: '#74b62d',
						weight: 4,
					};
				}
			});
			mapLayerWalls = omnivore.kml('/wp-content/plugins/mvmr/public/files/output_4_seicento.kml', null, layerMura);
			mapLayerWalls.addTo(map);
		},
	},

	mounted() {
		let self = this;

		// let htmlLang = document.getElementsByTagName('html')[0].lang;
		// if (!htmlLang || htmlLang === 'it') {
		// 	self.lang = 'it';
		// } else {
		// 	self.lang = 'en';
		// }

		globalLang = self.currentLang;

		console.log("Child initial: cookies allowed = " + self.cookiesAllowed);
		if(self.cookiesAllowed === true) {
			self.loadMap();
		}

		axios.get('/wp-json/mvmr/v1/get_itineraries_for_map' + '?lang=' + globalLang)
			.then(function (response) {
				console.log(response.data);
				self.allItineraries = response.data;
			})
			.catch(function (error) {
				console.log(error);
			});

		baguetteBox.run('.to-lightbox');
	}
}
</script>

<style lang="scss">
.no-cookies {
	display: flex;
	align-items: center;

	margin: 0.5em 0;
	border-top: 1px dotted lightgrey;
	padding: 0.5em 0;
	border-bottom: 1px dotted lightgrey;

	.fa-stack {
		font-size: 200%;
		margin-right: 1em;
	}
}

</style>
